<template>
  <div>
    <PeriodicTimerModal ref="PeriodicTimerModal" v-on:callbackSuccess="getTableData(table.page)"></PeriodicTimerModal>
    <SelectServer ref="SelectServer" v-on:selectServerComplete="selectServerComplete"></SelectServer>
    <Modal :title="editData.id ? '编辑': '新增'" v-model="editModal">
      <Form :model="editData" ref="editDataForm">
        <FormItem label="描述" prop="desc">
          <Input v-model="editData.desc" :maxlength="512"/>
        </FormItem>
        <FormItem label="模式" prop="model">
          <Select v-model="editData.model" :transfer="true">
            <Option v-for="item in modelList" :value="item.value" :key="item.value" :label="item.label"></Option>
          </Select>
        </FormItem>
        <FormItem label="存储服务商">
          <Select v-model="editData.support" style="min-width:250px" @on-change="supportChange">
            <Option v-for="item in allSupportList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="源路径" prop="source" v-if="editData.model === 'server_to_storage' || editData.model === 'storage_to_server'">
          <Input v-model="editData.source" :maxlength="512"/>
        </FormItem>
        <FormItem label="桶" prop="bucket" v-if="editData.model === 'delete_from_storage'">
          <Select v-model="editData.bucket" filterable>
            <Option v-for="item in bucketList" :value="item.name" :key="item.name">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem :label="editData.model === 'delete_from_storage' ? '删除目录': '目标路径'" prop="target">
          <Input v-model="editData.target" :maxlength="512"/>
        </FormItem>
        <FormItem label="服务器主机名" prop="hostname">
          <Input v-model="editData.hostname" :maxlength="512">
          <Button slot="append" icon="ios-search" @click="selectServer">选择</Button>
          </Input>
        </FormItem>
        <FormItem label="同时从存储删除数据" v-if="editData.model === 'server_to_storage'">
          <i-switch v-model="editData.is_delete_data">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
        <FormItem label="保留数据天数" prop="retention_day" v-if="editData.model === 'delete_from_storage' || (editData.is_delete_data && editData.model === 'server_to_storage')">
          <InputNumber v-model="editData.retention_day" :min="0"/>
        </FormItem>
        <Row>
          <div v-for="(param, index) in editData.params" :key="index">
            <Form ref="editParamsForm" :model="param" :rules="editParamRules" inline>
              <FormItem prop="paramName" style="width: 100%">
                <Input v-model="param.paramValue" placeholder="参数值" class="params-value">
                <Input v-model="param.paramName" placeholder="参数名" slot="prepend" style="width: 200px" size="small"/>
                <Button slot="append" icon="md-close" @click="removeParamItem(index)"></Button>
                </Input>
              </FormItem>
            </Form>
          </div>
          <Row>
            <a v-on:click="addParamItem()"><Icon type="md-add" /> 增加参数</a>
          </Row>
        </Row>
        <Divider/>
        <FormItem label="启动监控">
          <i-switch v-model="editData.monitor_enabled">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
        <FormItem label="监控指标" v-if="editData.monitor_enabled">
          <Input v-model="editData.monitor_metric" :maxlength="128" placeholder="填写监控的指标"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="editOk" :loading="editSubmitting">提交</Button>
        <Button @click="editModal = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
    <Modal title="执行结果" v-model="execHistoryResultModal" width="900">
      <Spin fix v-if="execHistoryResultLoading"></Spin>
      <Alert show-icon type="error" v-else-if="execHistoryResultErrMsg">{{ execHistoryResultErrMsg }}</Alert>
      <div v-else>
        <pre class="exec-history-result" :style="{color: execHistoryResult.code === 200 ? '#19be6b': '#ed4014'}">{{ execHistoryResult.result }}</pre>
      </div>
      <div slot="footer">
        <Button @click="execHistoryResultModal = false" style="margin-left: 8px">关闭</Button>
      </div>
    </Modal>
    <Modal title="执行日志" v-model="execHistoryModal" width="1400" footer-hide @on-cancel="execHistoryModalCancel">
      <Table
        class="exec-history-table-row"
        border
        :loading="execHistory.loading"
        :data="execHistory.data"
        :columns="execHistory.columns">
      </Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: right;">
          <page
            :total="execHistory.count"
            :current="execHistory.page"
            :page-size="execHistory.size"
            @on-change="history"></page>
        </div>
      </div>
    </Modal>
    <Card>
      <Row>
        <div style="float: right; margin-bottom: 5px">
          <Button icon="md-refresh" @click="getTableData(table.page)" style="margin-right: 8px"></Button>
          <Button type="primary" @click="addOpen">新增任务</Button>
        </div>
      </Row>
      <Row>
        <Table
          border
          :loading="TableLoading"
          :data="table.data"
          :columns="table.columns">
        </Table>
        <div style="margin: 10px 0; overflow: hidden;">
          <div style="float: right;">
            <page
              :total="table.count"
              :current="table.page"
              :page-size="table.size"
              @on-change="getTableData"></page>
          </div>
        </div>
      </Row>
    </Card>
  </div>
</template>

<script>
import { getCronTransportList, editCronTransport, deleteCronTransport, getTransportLogList, getTransportLogResult } from '@/api/troop/troop'
import { getRate, getBuckets } from '@/api/s3/s3'
import PeriodicTimerModal from './components/periodic-timer'
import SelectServer from '@/view/ops-center/select-server'
import moment from 'moment'
import { getOpsCenterAllSupport } from '@/api/opscenter'

export default {
  name: 'list',
  components: {
    PeriodicTimerModal,
    SelectServer
  },
  data () {
    return {
      TableLoading: false,
      table: {
        data: [],
        columns: [
          {
            title: '描述',
            key: 'desc',
            tooltip: true,
            align: 'center',
            minWidth: 130,
            render: (h, params) => {
              if (params.row.desc) {
                return h('a', {
                  on: {
                    click: () => {
                      this.editOpen(params.row)
                    }
                  }
                }, [
                  h('span', params.row.desc)
                ])
              }
            }
          },
          {
            title: '模式',
            key: 'model_verbose',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '任务',
            align: 'center',
            tooltip: true,
            minWidth: 500,
            render: (h, params) => {
              let res = ''
              if (params.row.model === 'delete_from_storage') {
                let retD = ''
                if (params.row.retention_day) {
                  retD = `${params.row.retention_day}天前`
                }
                res = `删除存储桶 ${params.row.bucket} 中文件夹 ${params.row.target} 内 ${retD} 的文件`
              } else {
                res = `${params.row.source} -> ${params.row.target}`
              }
              if (Array.isArray(params.row.params)) {
                let paramsData = []
                for (let i in params.row.params) {
                  paramsData.push(params.row.params[i].paramName)
                  if (params.row.params[i].paramValue) {
                    paramsData.push(params.row.params[i].paramValue)
                  }
                }
                res += ` ${paramsData.join(' ')}`
              }
              return h('span', res)
            }
          },
          {
            title: '主机',
            key: 'hostname',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '最后修改',
            align: 'center',
            key: 'change_user_full_name',
            minWidth: 100,
            render: (h, params) => {
              let time = ''
              if (params.row.changed) {
                time = moment(params.row.changed).format('YYYY-MM-DD HH:mm:ss')
              }
              return h('Tooltip', {
                props: {
                  transfer: true
                }
              }, [
                h('span', params.row.change_user_full_name),
                h('div', {
                  slot: 'content'
                }, time)
              ]
              )
            }
          },
          {
            title: '最后传输',
            tooltip: true,
            align: 'center',
            key: 'changed',
            minWidth: 150,
            render: (h, params) => {
              if (params.row.last_transport) {
                let color = params.row.last_transport.color
                let status = color === 'red' ? '失败' : params.row.last_transport.status
                return h('span', {
                  style: {
                    'font-weight': 'bold',
                    color: color === 'green' ? '#19be6b' : color === 'red' ? '#ed4014' : color
                  }
                }, [
                  h('Time', {
                    props: {
                      time: params.row.last_transport.time,
                      interval: 60
                    }
                  }),
                  h('span', `  ${status}`)
                ])
              } else {
                return ''
              }
            }
          },
          {
            title: '定时器',
            align: 'center',
            minWidth: 70,
            render: (h, params) => {
              let periodicExamineBtnType = 'default'
              let periodicExamineBtnIcon = 'md-close'
              if (params.row.periodic_task) {
                if (params.row.periodic_task.enabled === true) {
                  periodicExamineBtnType = 'success'
                  periodicExamineBtnIcon = 'md-checkmark'
                }
              }
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: periodicExamineBtnType,
                    size: 'small',
                    icon: periodicExamineBtnIcon
                  },
                  on: {
                    click: () => {
                      this.$refs.PeriodicTimerModal.openModal(params.row.id)
                    }
                  }
                }, '定时器')
              ])
            }
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 110,
            render: (h, params) => {
              return h('div', [
                // h('Button', {
                //   style: {
                //     marginRight: '5px'
                //   },
                //   props: {
                //     type: 'info',
                //     size: 'small'
                //   },
                //   on: {
                //     click: () => {
                //       this.$router.push({
                //         name: 'network_strategy_detail',
                //         params: { 'id': params.row.id }
                //       })
                //     }
                //   }
                // }, '详情'),
                // h('Button', {
                //   style: {
                //     marginRight: '5px'
                //   },
                //   props: {
                //     type: 'warning',
                //     size: 'small'
                //   },
                //   on: {
                //     click: () => {
                //       this.editStrategy(params.row.id)
                //     }
                //   }
                // }, '编辑'),
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.execHistory.id = params.row.id
                      clearInterval(this.timer)
                      this.timer = null
                      this.setTimer()
                      this.history()
                      this.execHistoryModal = true
                    }
                  }
                }, '日志'),
                h('Poptip', {
                  props: {
                    transfer: true,
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.Delete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 1,
        page: 1,
        size: 15
      },
      modelList: [
        {value: 'server_to_storage', label: '服务器->存储'},
        {value: 'storage_to_server', label: '存储->服务器'},
        {value: 'delete_from_storage', label: '从存储删除'}
      ],
      editParamRules: {
        paramName: { required: true, trigger: 'blur', message: '参数名不能为空' },
        paramValue: { required: true, trigger: 'blur', message: '参数值不能为空' }
      },
      editData: {
        id: '',
        desc: '',
        model: '',
        support: '',
        source: '',
        target: '',
        hostname: '',
        is_delete_data: false,
        retention_day: 0,
        bucket: '',
        params: [],
        monitor_enabled: false,
        monitor_metric: ''
      },
      editRule: {
        desc: [
          {required: true, message: '不能为空', trigger: 'blur'}
        ],
        model: [
          {required: true, message: '请选择模式', trigger: 'change'}
        ],
        source: [
          {required: true, message: '不能为空', trigger: 'blur'}
        ],
        target: [
          {required: true, message: '不能为空', trigger: 'blur'}
        ],
        hostname: [
          {required: true, message: '不能为空', trigger: 'blur'}
        ],
        retention_day: [
          {required: false, message: '不能为空', trigger: 'blur', type: 'int'}
        ]
      },
      editModal: false,
      editSubmitting: false,
      execHistoryModal: false,
      execHistory: {
        id: '',
        data: [],
        columns: [
          {
            title: '模式',
            key: 'model_verbose',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '任务',
            align: 'center',
            tooltip: true,
            minWidth: 500,
            render: (h, params) => {
              let res = ''
              if (params.row.model === 'delete_from_storage') {
                let retD = ''
                if (params.row.retention_day) {
                  retD = `${params.row.retention_day}天前`
                }
                res = `删除存储桶 ${params.row.bucket} 中文件夹 ${params.row.target} 内 ${retD} 的文件`
              } else {
                res = `${params.row.source} -> ${params.row.target}`
              }
              if (params.row.params) {
                res += ` ${params.row.params}`
              }
              return h('span', res)
            }
          },
          {
            title: '主机',
            key: 'hostname',
            align: 'center',
            tooltip: true,
            minWidth: 150
          },
          {
            title: '执行开始时间',
            key: 'started',
            align: 'center',
            tooltip: true,
            minWidth: 170,
            render: (h, params) => {
              if (params.row.started) {
                return h('span', moment(params.row.started).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '执行结束时间',
            key: 'ended',
            align: 'center',
            tooltip: true,
            minWidth: 170,
            render: (h, params) => {
              if (params.row.ended) {
                return h('span', moment(params.row.ended).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '状态',
            key: 'status',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              if (params.row.status === '执行中') {
                return h('Progress', {
                  props: {
                    percent: params.row.transport_rate ? params.row.transport_rate : 0,
                    'stroke-color': ['#108ee9', '#87d068'],
                    status: 'active'
                  },
                  style: {
                    width: '80px'
                  }
                })
              } else if (params.row.status === '完成') {
                if (params.row.result_code === 200) {
                  return h('Progress', {
                    props: {
                      percent: 100,
                      'stroke-color': ['#108ee9', '#87d068'],
                      status: 'success'
                    },
                    style: {
                      width: '80px'
                    }
                  })
                } else {
                  return h('Progress', {
                    props: {
                      percent: 0,
                      status: 'wrong'
                    },
                    style: {
                      width: '80px'
                    }
                  })
                }
              } else {
                return h('span', params.row.status)
              }
            }
          },
          {
            title: '结果',
            align: 'center',
            tooltip: true,
            minWidth: 60,
            render: (h, params) => {
              return h('a', {
                on: {
                  click: () => {
                    this.getLogResult(params.row.id)
                  }
                }
              }, '查看')
            }
          }
        ],
        count: 1,
        page: 1,
        size: 10,
        loading: false
      },
      execHistoryResultErrMsg: '',
      execHistoryResultLoading: false,
      execHistoryResultModal: false,
      execHistoryResult: {},
      timer: null,
      bucketList: [],
      allSupportList: []
    }
  },
  created: function () {
    this.getTableData()
    // this.getBucketsData('')
    this.getAllSupport()
  },
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    supportChange (value) {
      this.getBucketsData(value)
    },
    // 获取表格数据
    getTableData (value = 1) {
      this.table.page = value
      let params = {
        size: this.table.size,
        page: this.table.page
      }
      this.TableLoading = true
      getCronTransportList(params).then(res => {
        this.TableLoading = false
        this.table.data = res.data.results
        this.table.count = res.data.count
      }).catch(res => {
        this.TableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取列表失败！服务器无响应'
          })
        }
      })
    },
    // 获取所有服务商
    getAllSupport () {
      getOpsCenterAllSupport({type: 9}).then(res => {
        this.allSupportList = res.data
      })
    },
    // 获取桶数据
    getBucketsData (value) {
      if (value) {
        let params = { id: value }
        getBuckets(params).then(res => {
          this.bucketList = res.data.data
        }).catch(res => {
          console.error(res.response)
        })
      } else {
        this.bucketList = []
      }
    },
    // 初始化编辑表单
    editFormReset () {
      this.editData = {
        id: '',
        desc: '',
        model: '',
        support: '',
        source: '',
        target: '',
        hostname: '',
        is_delete_data: false,
        retention_day: 0,
        bucket: '',
        params: [],
        monitor_enabled: false,
        monitor_metric: ''
      }
    },
    // 打开新增表单
    addOpen () {
      this.editFormReset()
      this.editModal = true
    },
    // 打开编辑策略
    editOpen (row) {
      this.editFormReset()
      this.editData.id = row.id
      this.editData.desc = row.desc
      this.editData.model = row.model
      this.editData.support = parseInt(row.support)
      this.getBucketsData(this.editData.support)
      this.editData.source = row.source
      this.editData.target = row.target
      this.editData.hostname = row.hostname
      this.editData.is_delete_data = row.is_delete_data
      this.editData.retention_day = row.retention_day
      this.editData.bucket = row.bucket
      this.editData.monitor_enabled = row.monitor_enabled
      this.editData.monitor_metric = row.monitor_metric
      if (!Array.isArray(row.params)) {
        this.editData.params = []
      } else {
        this.editData.params = JSON.parse(JSON.stringify(row.params))
      }
      this.editModal = true
    },

    addParamItem () {
      this.editData.params.push({
        paramName: '',
        paramValue: ''
      })
    },
    removeParamItem (index) {
      this.editData.params.splice(index, 1)
    },
    editOk () {
      if (!this.editData.desc) {
        this.$Message.error('描述不能为空！')
        return
      }
      if (!this.editData.model) {
        this.$Message.error('请选择模式！')
        return
      }
      if (!this.editData.support) {
        this.$Message.error('请选择存储服务商！')
        return
      }
      if (this.editData.model !== 'delete_from_storage') {
        if (!this.editData.source) {
          this.$Message.error('源路径不能为空！')
          return
        }
        if (!this.editData.target) {
          this.$Message.error('目标路径不能为空！')
          return
        }
      } else {
        if (!this.editData.target) {
          this.$Message.error('删除目录不能为空！')
          return
        }
        if (!this.editData.bucket) {
          this.$Message.error('请选择桶！')
          return
        }
      }
      if (!this.editData.hostname) {
        this.$Message.error('服务器主机名不能为空！')
        return
      }
      if (this.editData.monitor_enabled) {
        if (!this.editData.monitor_metric) {
          this.$Message.error('监控指标不能为空！')
          return
        }
      }
      let allValid = true
      for (let i in this.$refs.editParamsForm) {
        this.$refs.editParamsForm[i].validate((valid) => {
          if (!valid) {
            allValid = false
          }
        })
      }
      if (!allValid) {
        return false
      }
      this.editSubmitting = true
      if (this.editData.model !== 'server_to_storage') {
        this.editData.is_delete_data = false
      }
      if (this.editData.model === 'delete_from_storage') {
        this.editData.source = ''
      } else {
        if (this.editData.model !== 'server_to_storage' || !this.editData.is_delete_data) {
          this.editData.retention_day = 0
        }
        this.editData.bucket = ''
      }
      editCronTransport(this.editData, this.editData.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.editModal = false
        this.getTableData(this.table.page)
        this.editSubmitting = false
      }).catch(res => {
        this.editSubmitting = false
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    history (value, loading = true) {
      this.execHistory.page = value
      let params = {
        size: this.execHistory.size,
        page: this.execHistory.page,
        cron_transport: this.execHistory.id
      }
      this.execHistory.loading = loading
      getTransportLogList(params).then(res => {
        this.execHistory.loading = false
        this.execHistory.data = res.data.results
        this.execHistory.count = res.data.count
        for (let i in res.data.results) {
          if (res.data.results[i].status === '执行中') {
            this.getTransportRate(res.data.results[i].id, i)
          }
        }
      }).catch(res => {
        this.execHistory.loading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取列表失败！服务器无响应'
          })
        }
      })
    },
    Delete (strategy) {
      deleteCronTransport(strategy.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getTableData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    getTransportRate (taskId, index) {
      getRate({task_id: taskId}).then(res => {
        let oldData = JSON.parse(JSON.stringify(this.execHistory.data))
        this.execHistory.data[index].transport_rate = res.data.data
        this.execHistory.data = Object.assign(oldData, this.execHistory.data)
      })
    },
    // 自动刷新
    setTimer () {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.history(this.execHistory.page, false)
        }, 5000)
      }
    },
    execHistoryModalCancel () {
      clearInterval(this.timer)
      this.timer = null
    },
    selectServer () {
      this.$refs.SelectServer.openSelectServerModal({troop_status: true}, {}, '', true)
    },
    selectServerComplete (server) {
      if (Object.keys(server).length) {
        this.editData.hostname = Object.keys(server)[0]
      } else {
        this.editData.hostname = ''
      }
    },
    getLogResult (id) {
      this.execHistoryResultErrMsg = ''
      this.execHistoryResultLoading = true
      this.execHistoryResultModal = true
      getTransportLogResult(id).then(res => {
        this.execHistoryResultLoading = false
        this.execHistoryResult = res.data.result
      }).catch(res => {
        this.execHistoryResultLoading = false
        this.execHistoryResultErrMsg = '数据获取失败'
      })
    }
  }
}
</script>

<style>
  .params-value .ivu-input-default {
    height: 34px;
  }
  .exec-history-result {
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -o-pre-wrap;
    word-wrap: break-word;
  }
  .exec-history-table-row .ivu-progress {
    margin-bottom: 0 !important;
  }
</style>
